export async function getDashboardData() {
  try {
    const res = await fetch("/tracka-flow/v1/HR_DASHBOARD_LOAD", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({

      })
    });

    const data = await res.json();

    return data;

  } catch (error) {
    console.error("API Error:", error);

    return {
      quote: "Welcome to FuMind.GI 🚀",
      news: []
    };
  }
}